import React, {Component} from 'react';
import {connect} from 'react-redux';
import {tryLogin} from "../state/action/apiActions";
import {LOGIN_USER, REQUEST_PENDING} from "../constant/reducerConstants";
import '../style/Login.css';
import Icon, {CAMERA, CLOSE, LOADING} from "./Icon";
import Scanner from "./Scanner";
import TaskQR from "../domain/TaskQR";

export class Login extends Component {
    state = {
        scannerOn: false,
        scannerKey: 1
    };

    toggleScanner = () => {
        console.log('toggle scanner');
        this.setState({scannerOn: !this.state.scannerOn});
    };

    submitLogin = event => {
        event.preventDefault();
        this.props.tryLogin(new TaskQR({
            taskId: event.target.taskId.value,
            pin: event.target.pin.value
        }));
    };

    submitLoginScan = result => {
        this.props.tryLogin(new TaskQR(result));
        this.setState({scannerOn: false});
    };

    render() {
        return (
            <div className={'login-wrapper'}>
                {this.props.authCheck === REQUEST_PENDING ?
                    <div className={'login-auth-pending'}>
                        <div>
                            Authentication pending
                        </div>
                        <Icon iconName={LOADING} spin={true} fill={'black'}/>
                    </div> :
                    this.state.scannerOn === true ?
                        <React.Fragment>
                            <button onClick={this.toggleScanner}><Icon iconName={CLOSE}/></button>
                            <Scanner
                                key={this.state.scannerKey}
                                validate={TaskQR.isTaskQR}
                                onDetected={this.submitLoginScan}
                                onValidateFail={() => this.setState({scannerKey: this.state.scannerKey + 1})}
                            />
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className={'card'}>
                                <form className={'login-form-wrapper'} onSubmit={this.submitLogin}>
                                    <div className={'login-input-wrapper'}>
                                        <label>Task Id:</label>
                                        <input className={'login-input-field'} name={'taskId'} type={'text'}/>
                                    </div>
                                    <div className={'login-input-wrapper'}>
                                        <label>Pin:</label>
                                        <input className={'login-input-field'} name={'pin'} type={'password'}/>
                                    </div>
                                    <div className={'login-submit-button'}>
                                        <button type={'submit'}>Submit</button>
                                    </div>
                                </form>
                            </div>
                            <button onClick={this.toggleScanner}><Icon iconName={CAMERA}/></button>
                        </React.Fragment>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {network} = state;
    return {
        authCheck: network[LOGIN_USER]
    };
};

const mapDispatchToProps = dispatch => {
    return {
        tryLogin: (credential) => {
            dispatch(tryLogin(credential));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/component/Login.jsx